module.exports = __webpack_public_path__ + "static/img/1_1_1.7e2f5cd5.jpg";